var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DocumentEntityType } from '@/components/AddDocumentDialog/AddDocumentDialog';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import { DocumentableType } from '@/models/StudentDocumentTemplate';
import SubjectStatusCount from '@/components/curriculum/SubjectStatusCount.vue';
import Curriculum from '@/components/curriculum/Curriculum.vue';
let AddCurriculumToDocumentDialog = class AddCurriculumToDocumentDialog extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.visible = {};
        this.expanded = {};
        this.isLoadingTopic = {};
        this.subjects = [];
        this.DocumentEntityType = DocumentEntityType;
        this.selectedSubjects = [];
        this.isNestedCurriculum = true;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    onSelectedSubjectsChanged(selectedSubjects) {
        this.selectedSubjects = selectedSubjects;
    }
    onAddPayloadToDocument() {
        this.$emit('addCurriculumToDocument', this.selectedSubjects);
    }
    onClose() {
        this.$emit('close');
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get user() {
        return this.$store.state.Auth;
    }
    get documentableType() {
        return this.entityType === DocumentEntityType.GROUP ? DocumentableType.GROUP : DocumentableType.PROJECT;
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Object)
], AddCurriculumToDocumentDialog.prototype, "entityType", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Object)
], AddCurriculumToDocumentDialog.prototype, "entity", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_e = typeof CurriculumModel !== "undefined" && CurriculumModel) === "function" ? _e : Object)
], AddCurriculumToDocumentDialog.prototype, "curriculum", void 0);
AddCurriculumToDocumentDialog = __decorate([
    Component({
        components: {
            Curriculum,
            SubjectStatusCount,
        },
    })
], AddCurriculumToDocumentDialog);
export default AddCurriculumToDocumentDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
